import React from 'react';
import { useTranslation } from 'react-i18next';
import ReportForm from '../ReportForm';

const RetentionReportOfSentDocs:React.FC = () => {
    const { t } = useTranslation();

    return <ReportForm title={t('reports.RetentionData.title')} serviceName="customCaseManagementServices" APIName="getRetentionReportOfSentDocs" savedFileName={t('reports.RetentionData.title')} />;
};

export default RetentionReportOfSentDocs;
